module.exports = __webpack_public_path__ + "h5/img/noCart.50b36491.png";